export const formatAmount = (value: number | string): string => {
  return typeof value === "number" ? value.toFixed(2) : parseFloat(value).toFixed(2);
}